import axios from 'axios'

export const http = axios.create({
  baseURL: 'https://app.webreceita.com.br/account'
})